import { render } from "./ModalVerDetallePertenencia.vue?vue&type=template&id=16c26c38&scoped=true"
import script from "./ModalVerDetallePertenencia.vue?vue&type=script&lang=js"
export * from "./ModalVerDetallePertenencia.vue?vue&type=script&lang=js"

import "./ModalVerDetallePertenencia.vue?vue&type=style&index=0&id=16c26c38&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c26c38"]])

export default __exports__